import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { menuList } from '@/config/menu'
import { APP_NAME } from '@/config/app'

Vue.use(VueRouter)

const AdminLayout = () => import('@/layout/AdminLayout.vue')
const Login = () => import('@/views/login/Login.vue')
const TemplateList = () => import('@/views/templates/TemplateList.vue')
const MiniProgramList = () => import('@/views/mini-programs/MiniProgramList.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', public: true }
  },
  {
    path: '/',
    component: AdminLayout,
    redirect: '/mini-programs',
    children: [
      {
        path: 'mini-programs',
        name: 'MiniProgramList',
        component: MiniProgramList,
        meta: { title: '小程序配置', menuIndex: 'mini-programs' }
      },
      {
        path: 'templates',
        name: 'TemplateList',
        component: TemplateList,
        meta: { title: '模板管理', menuIndex: 'templates' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/mini-programs'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `${to.meta.title} - ${APP_NAME}`
    : APP_NAME

  if (to.meta.public) {
    if (store.getters.isLoggedIn && to.path === '/login') {
      next('/')
    } else {
      next()
    }
    return
  }

  if (!store.getters.isLoggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

export { menuList }
export default router
